<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? 'Добавить' : 'Редактировать'}} тему поддержки</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Назад</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? 'Добавить' : 'Редактировать'}} тему поддержки</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-lg-6 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Тема поддержки</h6>
            </div>
            <div>
              <ValidationObserver tag="form" ref="supportCategoryForm" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                      <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                        <label for="name">Название</label>
                        <input class="form-control" id="name" v-model="formData.name[language.code]" :class="classes" placeholder="Название" type="text">
                      </ValidationProvider>
                      <button type="submit" class="btn ripple btn-main-primary">{{isCreate?'Сохранить':'Обновить'}}</button>
                  </b-tab>
                </b-tabs>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SupportCategoryAdd',
  data () {
    return {
      formData: {
        name: {}
      },
      supportCategoryId: '',
      isCreate: false
    }
  },
  created () {
    this.getLanguages().catch(() => {
      this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
    })
    this.supportCategoryId = this.$route.params.id
    if (this.supportCategoryId === 'add') {
      this.isCreate = true
    } else {
      this.getSupportCategory(this.supportCategoryId).then(res => {
        this.formData = res.data
      })
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages
    })
  },
  methods: {
    ...mapActions({
      createSupportCategory: 'supportCategory/create',
      updateSupportCategory: 'supportCategory/update',
      getLanguages: 'language/getLanguages',
      getSupportCategory: 'supportCategory/getSupportCategory'
    }),
    formSubmit () {
      this.$refs.supportCategoryForm.validate().then(success => {
        if (success) {
          if (this.isCreate) {
            this.createSupportCategory(this.formData).then(() => {
              this.$router.push('/support-category')
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            })
          } else {
            this.updateSupportCategory({ data: this.formData, id: this.supportCategoryId }).then(() => {
              this.$router.push('/support-category')
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
